/**
 * Resolve where to send the user when they click "Create Event".
 * Phase 17A: organization admins/managers may create without an organizer profile.
 */
import { isOrganizationStaffRole, isOrganizerRole } from '@/lib/rbac';

export const CREATE_EVENT_REDIRECT_PARAM = 'redirect=create-event';

export type CreateEventWorkspace = 'organization' | 'personal';

export function userCanCreateEvents(role: unknown): boolean {
  return isOrganizerRole(role) || isOrganizationStaffRole(role);
}

export function getCreateEventPath(options: {
  isAuthenticated: boolean;
  /** @deprecated Use canCreateEvents */
  isOrganizer?: boolean;
  canCreateEvents?: boolean;
  workspace?: CreateEventWorkspace;
  organizationId?: string;
}): string {
  if (!options.isAuthenticated) {
    return `/login?${CREATE_EVENT_REDIRECT_PARAM}`;
  }

  const canCreate =
    options.canCreateEvents ??
    options.isOrganizer ??
    false;

  if (canCreate) {
    const params = new URLSearchParams();
    if (options.workspace) {
      params.set('workspace', options.workspace);
    }
    if (options.organizationId) {
      params.set('organization_id', options.organizationId);
    }
    const query = params.toString();
    return `/dashboard/events/new${query ? `?${query}` : ''}`;
  }

  return '/become-organizer';
}

export function getRedirectAfterLogin(
  redirectParam: string | null,
  role: unknown
): string | null {
  if (redirectParam !== 'create-event') return null;
  return userCanCreateEvents(role) ? '/dashboard/events/new' : '/become-organizer';
}
